
@if (!emailOk) {
  <button class="btn btn-primary mx-2" (click)="enviarEmail()" [disabled]="loadingEmail">
    Esqueci minha assinatura eletrônica
    @if (loadingEmail) {
      <i class="fas fa-spinner fa-spin"></i>
    }
  </button>
}

@if (emailOk) {
  <div>
    <form [formGroup]="form">
      <p class="mb-3 pr-5">
        <strong>Digite o código de verificação enviado para seu email no campo abaixo:</strong>
      </p>
      <div class="form-row">
        <div class="form-group col-md-2">
          <label>Código de Verificação</label>
          <input type="text" class="form-control" formControlName="token" placeholder="">
          @if (!this.form.get('token').valid) {
            <div>
              @if (this.form.get('token').touched) {
                <div>
                  <small class="text-danger">
                    Campo Obrigatório
                  </small>
                </div>
              }
            </div>
          }
        </div>
      </div>
      <p class="mt-5 mb-3 pr-5">
        <strong>Digite sua nova assinatura eletrônica:</strong>
      </p>
      <div class="form-row">
        <div class="form-group col-md-3">
          <label>* Nova Assinatura Eletrônica</label>
          <input type="password" class="form-control" formControlName="assinatura" placeholder="">
          @if (!this.form.get('assinatura').valid && (this.form.get('assinatura').touched || this.form.get('assinatura').dirty)) {
            <div>
              @if (form.get('assinatura').hasError('required')) {
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              }
              @if (form.get('assinatura').hasError('minlength')) {
                <small class="text-danger">
                  A assinatura deve conter ao menos 8 caracteres
                </small>
              }
            </div>
          }
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-3">
          <label>Confirme sua Nova Assinatura</label>
          <input type="password" class="form-control" formControlName="confAssinatura" placeholder="">
          @if (!this.form.get('confAssinatura').valid && (this.form.get('confAssinatura').touched || this.form.get('confAssinatura').dirty)) {
            <div>
              @if (form.get('confAssinatura').hasError('required')) {
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              }
              @if (form.get('confAssinatura').hasError('minlength')) {
                <small class="text-danger">
                  A assinatura deve conter ao menos 8 caracteres
                </small>
              }
            </div>
          }
        </div>
      </div>
      <p class="mb-3 pr-5">
        <small>* A assinatura deve conter no mínimo <strong>8 caracteres</strong> entre <strong>letras</strong> e <strong>números</strong></small>
      </p>
      @if (msgErro!=null) {
        <div class="msgErroForm">
          {{msgErro}}
        </div>
      }
      <button class="btn btn-success mx-2" target="_blank" (click)="alterarAssinatura()" [disabled]="!form.valid || loadingSalvar">
        Alterar Assinatura
        @if (loadingSalvar) {
          <i class="fas fa-spinner fa-spin"></i>
        }
      </button>
    </form>
  </div>
}